import React, { useState } from 'react';
import { CustomFieldGroupType, CustomFieldType } from '../../components/forms/custom_fields/CustomFieldTypes';
import TabSelect from 'components/forms/basefields/TabSelect';
import FormMobilePreview from './FormMobilePreview';

interface FormMobilePreviewProps {
    formName: string;
    groups: CustomFieldGroupType[];
    fields: CustomFieldType[];
}

const FormPreview: React.FC<FormMobilePreviewProps> = ({
    formName,
    groups,
    fields,
}) => {
    const [deviceType, setDeviceType] = useState<'mobile' | 'pdf'>('mobile');

    // Get the fields without group and sort them
    const ungroupedFields = fields
        .filter(field => !field.group_id && !field.parent_field_id && !field.deleted)
        .sort((firstField, secondField) => firstField.ordering - secondField.ordering);

    return (
        <div className='form-builder-preview'>
            {/* <TabSelect<any>
                options={[
                    {
                        label: 'Mobiel',
                        value: 'mobile',
                    },
                    {
                        label: 'Pdf',
                        value: 'pdf',
                    },
                ]}
                selectedOption={{
                    label: deviceType,
                    value: deviceType,
                }}
                optionFormat='label'
                onChange={(value) => {
                    setDeviceType(value as 'mobile' | 'pdf');
                }}
            /> */}

            {deviceType === 'mobile' && (
                <div className='mobile-preview'>
                    <div className='mobile-screen'>
                        <div className='ios-preview-header'>
                            <button
                                type='button'
                                className='ios-preview-header-back-button'
                                aria-label='Terug'
                            >
                                <span className='ios-preview-header-back-icon'>
                                    ‹
                                </span>
                            </button>

                            <strong className='ios-preview-header-title'>
                                {formName}
                            </strong>

                            <span className='ios-preview-header-side' />
                        </div>

                        <div className='mobile-screen-content'>
                            {/* Ungrouped fields */}
                            {ungroupedFields.map(field => (
                                <FormMobilePreview 
                                    key={field.id || field.uuid} 
                                    field={field}
                                    fields={fields}
                                />
                            ))}

                            {/* Grouped fields */}
                            {groups.filter(group => !group.deleted).map(group => {

                                // Get the group identified
                                const groupIdentifier = group.id || group.uuid;

                                // Get the group fields
                                const groupFields = fields
                                    .filter(field =>
                                        String(field.group_id) === String(groupIdentifier) &&
                                        !field.parent_field_id &&
                                        !field.deleted
                                    )
                                    .sort((firstField, secondField) => firstField.ordering - secondField.ordering);

                                return (
                                    <div
                                        key={groupIdentifier}
                                        className='mobile-preview-group'
                                    >
                                        <div className='mobile-preview-group-header'>
                                            <h3>
                                                {group.title}
                                            </h3>
                                            {group.description && (
                                                <p>
                                                    {group.description}
                                                </p>
                                            )}
                                        </div>

                                        {groupFields.map(field => (
                                            <FormMobilePreview  
                                                key={field.id || field.uuid} 
                                                field={field}
                                                fields={fields}
                                            />
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FormPreview;